module.exports = __webpack_public_path__ + "img/30-days-challenge.96850ca4.webp";